/**
 * Marks a portion of text intended to represent a numeral
 */
export class Numeral extends HTMLElement {
  _updateRendering() {
    // ...
  }
}
